import { Link, Text } from '@customerio/pluma-components/react';
import { AccountFeatureFlag, useFeatureFlag } from '@/services/auth/feature-flags';
import { formatNumber } from '@/utils/number';
import type { PlanDetails } from '../../use-plan-details';

const HOW_WE_BILL_HREF = 'https://docs.customer.io/accounts-and-workspaces/how-we-bill/';

type PlanInfoProps = {
  planDetails: PlanDetails;
};

export function PlanInfo({ planDetails }: PlanInfoProps) {
  const isNewPricing = useFeatureFlag(AccountFeatureFlag.NewPipelinesObjectsPricing);

  if (isNewPricing) {
    return (
      <Text color="inherit" data-test-objects-landing-page-plan-info>
        Your plan includes {planDetails.objectTypeLimit} object types, and you can have any combination of people and
        objects you like.{' '}
        <Link href={HOW_WE_BILL_HREF} isExternal={true} variant="secondary">
          Learn how we bill for profiles
        </Link>
        .
      </Text>
    );
  }

  return (
    <Text color="inherit" data-test-objects-landing-page-plan-info>
      Your plan includes {planDetails.objectTypeLimit} object types and {formatNumber(planDetails.baseObjectCount)}{' '}
      profiles. Additional object profiles will be billed at ${planDetails.baseMeteredObjectRate}/profile.
    </Text>
  );
}
